import axios from 'axios'

import { reatailmediaApi as baseAPI } from '../../api'

export const getAdvertiserConfigurationKey = 'getAdvertiserConfiguration'

type AdvertiserConfigurationResponse = {
  configuration: { allow_ntb_metrics: boolean }
}

// Flags por conta de anunciante (o BFF resolve a conta da sessão)
export const getAdvertiserConfigurationService = () =>
  axios.get<AdvertiserConfigurationResponse>(
    `${baseAPI}/configuration/advertiser`
  )
